module.exports = __webpack_public_path__ + "img/融易.65b2bf65.png";